// extracted by mini-css-extract-plugin
export default {"disclaimer":"PublishProcessCommentModal_disclaimer__Z-bgz"};